import React, {Component} from 'react';
import NewsCard from './NewsCard';
import {fetchJson} from '../fetchJson';
import handleError from '../handleError';
import {connect} from 'react-redux';

class NewsSection extends Component {
	constructor() {
		super();

		this.state = {news: null};
	}

	componentDidMount() {
		fetchJson('https://b2me.com.au/b2menews/latestnews.json')
			.then(news => this.setState({news}))
			.catch(this.props.handleError); // Ignore
	}

	render() {
		const {news} = this.state;

		if (!news) return null;

		return (
			<div className="NewsSection">
				<ul>
					{news.map(item => (
						<li key={`${item.formattedDate}_${item.title}`}>
							<NewsCard
								href={item.href}
								thumbnailSrc={item.thumbnailSrc}
								title={item.title}
								vendor={item.vendor}
								formattedDate={item.formattedDate}
								description={item.description}
							/>
						</li>
					))}
				</ul>
			</div>
		);
	}
}

const ConnectedNewsSection = connect(
	() => ({}),
	dispatch => ({
		handleError: handleError(dispatch)
	})
)(NewsSection);

export default ConnectedNewsSection;



// WEBPACK FOOTER //
// ./src/home/NewsSection.js